<template>
    <div class="outer">
        <div class="inner">
            <div>
                <MarketIconWithBackground
                    :text="
                        `${
                            forecastWindows && forecastWindows.length > 0
                                ? forecastWindows.filter(fw => fw.status === FORECAST_WINDOW_STATUS.SUBMITTED).length
                                : 0
                        }/${forecastWindows.length}`
                    "
                />
            </div>
        </div>
        <div class="inner">
            <div><ListIconWithBackground :text="`${forecast.numberOfItems}`" /></div>
        </div>
    </div>
</template>
<script>
import MarketIcon from "@/components/forecasts/elements/icons/MarketIcon";
import ItemsIcon from "@/components/forecasts/elements/icons/ItemsIcon";
import MarketIconWithBackground from "@/components/forecasts/elements/icons/MarketIconWithBackground";
import ListIconWithBackground from "@/components/forecasts/elements/icons/ListIconWithBackground";
import { FORECAST_WINDOW_STATUS } from "@/components/forecasts/constants";

export default {
    components: {
        ListIconWithBackground,
        MarketIconWithBackground,
        ItemsIcon,
        MarketIcon
    },
    props: {
        forecast: {
            type: Object,
            required: true
        },
        forecastWindows: {
            required: false
        }
    },
    data() {
        return {
            FORECAST_WINDOW_STATUS
        };
    }
};
</script>
<style scoped lang="scss">
.outer {
    display: flex;
    .inner {
        margin-right: 15px;
    }
}
</style>



// WEBPACK FOOTER //
// ForecastInfos.vue?7bb62529